import { AdobeBaseEvent } from './adobe-base-event';
import { AnalyticsEventType } from '../models';
import { Store } from 'vuex';
import { AppState } from '@/store';
import { ServicesContainer } from '@/services';
import { RewardsPageLoadEvent } from '@/services/analytics/events/rewards-page-load-event';

export class AdobeRewardsPageLoadEvent extends AdobeBaseEvent {
    name = 'AdobeRewardsPageLoadEvent';
    event = AnalyticsEventType.PageLoaded;

    constructor(
        event: RewardsPageLoadEvent,
        store: Store<AppState>,
        services: ServicesContainer,
    ) {
        super(store, services);
        this.web.webPageDetails.name = `rewards:${event.pageName}`;
        this.web.webPageDetails.siteSection = 'rewards';
        this.web.webPageDetails.pageViews = { value: 1 };
    }
}